import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '@shared/hooks/useSession';
import { PageSpinner } from '@ui/PageSpinner';

export function AdminGuard() {
  const { data: user, isLoading } = useSession();
  const { pathname } = useLocation();

  if (isLoading) return <PageSpinner />;
  if (!user) {
    const next = encodeURIComponent(pathname);
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
